module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page v. ",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugold0006#ch01"
    }
  }, [_vm._v("Translator’s Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rheads"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugold0007#heads"
    }
  }, [_c('i', [_vm._v("Your Comrade, Avreml Broide")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugold0010#pt01"
    }
  }, [_vm._v("First Part: The City of the Shtetl")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugold0020#pt02"
    }
  }, [_vm._v("Second Part: The City of New York")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rch21"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugold0032#ch21"
    }
  }, [_vm._v("Translator’s Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81442690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-gold-0005.vue
// module id = 66
// module chunks = 0